/*
 *
 * ATTENTION: HOW THIS ITEMS ARE DRAGGED.
 * There is no device/props to tell DragSortableList to distinguish which item is draggable or not.
 * So instead, we modify the very first childnode of each draggable item to tell which item is not
 * draggable. Here that first childnode is <EditItem />. By adding class 'do-not-drag-my-parent,'
 * The item is not draggable anymore.
 *
 */
import React, {Component} from 'react'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux';
import Loading from 'components/UI/Loading'
import Transition from 'components/UI/Transition'
import moment from 'moment'
import { alert } from 'util/alert';
import { confirm } from 'util/confirm';

import TicketList from './TicketList'
import EditItem from './EditItem'
import './EditPoster.scss'
import PanelWrapper from 'components/UI/PanelWrapper'
import updatePoster from 'controllers/poster/updatePoster'
import {
  fetchPosterDetail,
  updateTitle,
  updateTicket,
  createTicket,
  deleteTicket,
  updateContentItem,
  addContentItem,
  removeContentItem,
} from './ducks'
import locale from './locale';

import './DefaultEditor.scss';

const mapStateToProps = (state) => ({
  user: state.user,
  posterDetail: state.posterDetail,
});

class EditPoster extends Component{
  constructor(props){
    super(props)

    this.state = {
      date: '',
      title: '',
      text: '',
      result: false,
      content_block_id: '',
      poster_type: '',
      contents: [],
    }

    this.onTitleChange = this.onTitleChange.bind(this)
    this.onContentChange = this.onContentChange.bind(this)
    this.onImageChange = this.onImageChange.bind(this)
    this.addItem = this.addItem.bind(this)
    this.countEmptyItem = this.countEmptyItem.bind(this)
    this.onTicketChange = this.onTicketChange.bind(this)
    this.addTicket = this.addTicket.bind(this)
    this.removeTicket = this.removeTicket.bind(this)
    this.savePoster = this.savePoster.bind(this)
    this.removeItem = this.removeItem.bind(this);
    this.removeItemWithoutConfirm = this.removeItemWithoutConfirm.bind(this);
    this.insertTextContentWhereItNeeded = this.insertTextContentWhereItNeeded.bind(this);
    this.combineTextContentIfTheyAreSideBySide = this.combineTextContentIfTheyAreSideBySide.bind(this);

  }

  componentDidMount(){
    const posterId = this.props.params.posterId
    this.props.fetchPosterDetail(posterId);
  }

  componentWillReceiveProps({posterDetail}){
    if(posterDetail.detail.state == 1){
      alert.fail(__('Unable to Edit Published Poster', locale)).then((res) => {browserHistory.push('/poster')})
    }

    if(posterDetail){
      this.setState({
        title: posterDetail.title,
        contents: posterDetail.contentList.length == 0 ? [{}] : posterDetail.contentList,
      })
    }
  }

  renderPosterDate(){

    if(!this.props.posterDetail.detail){
      return(
        <Loading />
      )
    }

    let updated_at = this.props.posterDetail.detail.updated_at
    let newDate = moment(updated_at).format(__('MMM DD, YYYY', 'dateFormat'))
    return newDate

  }

  // dontCallAPI is true, when we add a temporary item
  addItem(index, newContentItem, dontCallAPI) {
    const {
      posterId,
    } = this.props.params;

    this.props.addContentItem(index, posterId, newContentItem, dontCallAPI);
  }

  removeItem(index, contentId, content_type){
    let textContentLength = this.getTextContentNum();

    if (textContentLength === 1 && content_type === 'string') {
      return;
    }

    if (content_type === 'picture') {
      confirm(__('Are you sure you want to delete the picture?', locale), __('Delete Content', locale))
        .then(()=>{
          this.execRemoveItem(index, contentId)
        })
        .catch(()=>{});
      return
    }

    if (content_type === 'text') {
      this.execRemoveItem(index, contentId)
    }

  }

  getContent(index) {
    return this.state.contents[index];
  }

  getTextContentNum() {
    let num = 0;
    this.state.contents.map((item)=>{
      if (item.content_type == 'text') {
        num++;
      }
    });
    return num;
  }

  removeItemWithoutConfirm(index, contentId){
    this.execRemoveItem(index, contentId);
  }

  execRemoveItem(index, contentId) {
    // if this is a last text item. We do not delete it
    this.props.removeContentItem(index, contentId);
  }

  countEmptyItem(){
    let emptyContents = this.state.contents.filter((content) => {
      return !content.content_type
    })
    this.setState({emptyContentsCount: emptyContents.length})
  }

  onTitleChange(event){
    const posterId = this.props.params.posterId
    const title = event.target.value;

    clearTimeout(this.updateTextTimeout);
    this.props.updateTitle(title);

    this.updateTextTimeout = setTimeout(()=>{
      updatePoster(posterId, {title})
        .then((res) => {console.log(res)})
    }, 500);
  }

  onContentChange(index, contentItemChanges){
    const {
      posterId
    } = this.props.params;

    clearTimeout(this.updateTextTimeout);

    let contents = this.state.contents;

    let contentId = contents[index].content_block_id || contents[index].id

    this.updateTextTimeout = setTimeout(()=>{
      this.props.updateContentItem(index, contentId, contentItemChanges);
    }, 500);
  }

  onImageChange(index, contentItemChanges){
    this.onContentChange(index, contentItemChanges);
  }

  addTicket(type) {
    const {params} = this.props;
    const {posterId} = params
    const {ticketList = []} = this.props.posterDetail

    this.props.createTicket(posterId, {title: '', index: ticketList.length + 1, price_type: type})
  }

  removeTicket(index, ticket) {

    return () => {
      const { endDate, endTime, title, price } = ticket;
      const priceFloat = typeof price === 'undefined' ? price : parseFloat(price);

      if (endDate || endTime || title || priceFloat) {
        confirm(__('Proceed to delete this registration?', 'ticket')).then(() => {
          this.props.deleteTicket(ticket.id, index)
        })
      } else {
        this.props.deleteTicket(ticket.id, index)
      }

    }

  }

  onTicketChange(index, ticketId){
    return (newSettings) => {
      clearTimeout(this.updateTextTimeout);

      this.updateTextTimeout = setTimeout(()=>{
        this.props.updateTicket(ticketId, newSettings)
      }, 500);

    }
  }

  savePoster(){
    const {params} = this.props;
    const {posterId} = params;

    browserHistory.push('/poster')
  }

  insertTextContentWhereItNeeded() {
    const { contents } = this.state;
    const length = contents.length;
    const lastContent = this.getContent(length - 1) || {};

    // Case 1:
    // if the last content is not a 'text' content
    if (lastContent.content_type === 'picture') {
      this.addItem(length, {
        content_type: 'text',
        text: '<p><br></p>',
      });
    }

  }

  combineTextContentIfTheyAreSideBySide() {
    const { contents } = this.state;
    const length = contents.length;
    const lastContent = this.getContent(length - 1) || {};

    // Case 1:
    // if the last content is not a 'text' content
    if (lastContent.content_type === 'picture') {
      this.addItem(length, {
        content_type: 'text',
        text: '<p><br></p>',
      });
    }

  }

  getPosterTitle() {
    let { poster_type, } = this.props.posterDetail

    switch (poster_type) {
      case 'basic':
        return __('Create New Basic Poster', locale)
        break;
      case 'registration':
        return __('Create New Registration Poster', locale)
        break;
     }
  }

  render(){
    let {emptyContentsCount, contents} = this.state;
    let { ticketList, poster_type, fetching, hasTitle, } = this.props.posterDetail

    const {params} = this.props;
    const {posterId} = params

    if (fetching !== true) {
      this.insertTextContentWhereItNeeded();
      // this.combineTextContentIfTheyAreSideBySide();
    }

    const EditItems = contents.map((content, key) => {
      return <EditItem
                content={content}
                contentId={content.id}
                key={key}
                {...this.props}
                addItem={this.addItem}
                removeItem={this.removeItem}
                removeItemWithoutConfirm={this.removeItemWithoutConfirm}
                index={key}
                emptyContentsCount={emptyContentsCount}
                contentId={content.content_block_id ? content.content_block_id : content.id}
                onContentChange={(index, value) => {this.onContentChange(index, value)}}
                onImageChange={(index, value) => {this.onImageChange(index, value)}} />
    })


    if (fetching) {
      return (
        <PanelWrapper>
          <Loading />
        </PanelWrapper>
      );
    }

    return(
      <PanelWrapper>
        <Transition>
        <div className='container-fluid poster-container'>
          <div className='header'>
            <span className='create-poster-title'>{this.getPosterTitle()}</span>
            <div className='poster-date'>{__('Last Updated: ', locale)}{this.renderPosterDate()}</div>
            { hasTitle === true &&
            <div className='buttons'>
              <button className="btn btn-default" onClick={this.savePoster}>{__('Save', locale)}</button>
              <a href={`/poster-preview/${posterId}`} target='_blank'>
                <button className="btn btn-warning" onClick={() => {
                  }}>{__('Preview', locale)}</button>
              </a>
              <button className="btn btn-primary" onClick={() => {
                updatePoster(posterId, {state: 'published'})
                .then((res) => { browserHistory.push('/poster') })
              }}>{__('Publish', locale)}</button>
            </div> }

          </div>
          <div className='row'>
            <div className='col-xs-8'>
              <div className='default-editor'>
                <input
                  className='form-control poster-title'
                  placeholder={__('Enter Poster Title', locale)}
                  value={this.state.title}
                  onChange={this.onTitleChange}
                />
                <div className='EditItemList'>
                  {EditItems}
                </div>
                <Transition> 
                  {poster_type == 'registration' && hasTitle && 
                    <TicketList
                      ticketList={ticketList}
                      onTicketChange={this.onTicketChange}
                      addTicket={this.addTicket}
                      removeTicket={this.removeTicket}
                  />
                  }
                </Transition>
                </div>
              </div>
              { /*
              <div className='col-xs-4'>
                <Template />
              </div>
               */ }
            </div>
          </div>
          </Transition>
        </PanelWrapper>
      )
    }
  }

export default connect(mapStateToProps, {
  fetchPosterDetail,
  updateTitle,
  updateTicket,
  createTicket,
  deleteTicket,

  updateContentItem,
  removeContentItem,
  addContentItem,
})(EditPoster)



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster-archieve/index.js